import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import { getStaticFileUrl } from "../utils/staticFiles";
export const Logo = () => {
    return (_jsx(Box, { component: Link, to: "/", sx: { display: "flex", alignItems: "center" }, "aria-label": "Log.Soccer Home", children: _jsx("img", { alt: "Log.Soccer", height: "30px", loading: "lazy", src: getStaticFileUrl("images", "white-logo-no-background.png") }) }));
};
